// extracted by mini-css-extract-plugin
export var container = "styles-module__container____bii7";
export var label = "styles-module__label___Ew2RE";
export var labelAndSelect = "styles-module__labelAndSelect___ybTYo";
export var select = "styles-module__select___nHtDA";